import {
    DIALOGS,
    SCHOOL_INFO,
    QUESTIONNAIRE,
    CONTACT_DATA,
    REQUESTS,
    MOVE_IN,
    CLICKED_COMPANIES,
    SEARCH_TYPE, SCREEN_NAME, WIDGET_PROPS, WIDGET_SCHOOL_LOADING,
} from '../types';
// import {MOVE_IN_BUTTONS} from "../../constants/MoveInButtons";
import {PETS_BUTTONS} from "../../constants/PetsButtons";
import {FEATURES_BUTTONS} from "../../constants/FeaturesButtons";

const initialState = {
    dialogs: [],
    schoolInfo: {},
    questionnaire: {
        bedrooms: 2,
        bathrooms: 1,
        budgets: 1200
    },
    contact: {},
    requests: [],
    moveIn: {
        selectDefault: {value: 0, label: 'As soon as possible'},
        // buttonsDefault: MOVE_IN_BUTTONS,
        // buttonsDefaultResult: [],
        pets: PETS_BUTTONS,
        petsSelected: [],
        features: FEATURES_BUTTONS,
        featuresSelected: [],
        moveInDate: null,
    },
    clickedCompanies: [],
    searchType: '',
    screenName: '',
    widgetProps: {
        location_type: "college",
        location_id: null,
        site: null,
    },
    widgetSchoolLoading: true,
};

const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case SCHOOL_INFO:
            return {
                ...state,
                schoolInfo: action.payload,
            };
        case QUESTIONNAIRE:
            return {
                ...state,
                questionnaire: action.payload,
            };
        case CONTACT_DATA:
            return {
                ...state,
                contact: action.payload,
            };
        case REQUESTS:
            return {
                ...state,
                requests: action.payload,
            };
        case MOVE_IN:
            return {
                ...state,
                moveIn: action.payload,
            };
        case CLICKED_COMPANIES:
            return {
                ...state,
                clickedCompanies: action.payload,
            };
        case SEARCH_TYPE:
            return {
                ...state,
                searchType: action.payload,
            };
        case SCREEN_NAME:
            return {
                ...state,
                screenName: action.payload,
            };
        case WIDGET_PROPS:
            return {
                ...state,
                widgetProps: action.payload,
            };
        case WIDGET_SCHOOL_LOADING:
            return {
                ...state,
                widgetSchoolLoading: action.payload,
            };
        case DIALOGS:
            return {
                ...state,
                dialogs: [action.payload],
            };
        default:
            return state;
    }
};

export default commonReducer;
